<template>
  <div>
    <div v-if="pageLoading" class="h-screen w-screen grid place-items-center">
      <div
        class="flex items-center font-logo font-bold text-4xl text-light-purple animate-pulse"
      >
        Blüm Report
      </div>
    </div>
    <div
      v-else-if="!report"
      class="h-screen w-screen grid place-items-center bg-white"
    >
      <div
        class="w-full lg:w-148 py-5 px-4 lg:px-10 flex flex-col items-center gap-2 bg-pure-white border-l-8 border-red-cherry rounded-xl shadow-lg"
      >
        <BlTextTitle4 text="404: Report Not Found" />
        <div class="flex flex-col">
          <BlTextBody2
            text="Oops! It looks like the report you're trying to access doesn't exist or the URL is incorrect. Please contact your therapist for assistance."
            class="text-center"
          />
        </div>
      </div>
    </div>
    <div v-else>
      <ReportHeader :mode="'preview'" />
      <div class="flex" :style="{ minHeight: 'calc(100vh - 3.75rem)' }">
        <ParentReportHelper
          :sectionFocusedId="sectionFocusedId"
          @change-focus-id="sectionFocusedId = $event"
        />

        <Editor :mode="'preview'" />

        <div class="w-20 flex-shrink-0"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import ReportHeader from "./ReportHeader.vue";
import Editor from "./Editor.vue";
import ParentReportHelper from "./ParentReportHelper.vue";

import BlTextTitle4 from "../BlTextTitle4.vue";
import BlTextBody2 from "../BlTextBody2.vue";

export default {
  name: "ParentReport",
  components: {
    ReportHeader,
    Editor,
    ParentReportHelper,
    BlTextTitle4,
    BlTextBody2
  },
  data() {
    return {
      pageLoading: true,
      sectionFocusedId: 0
    };
  },
  computed: {
    ...mapGetters(["report"])
  },
  watch: {
    sectionFocusedId(val) {
      if (!val) return;
      const el = document.getElementById(`report-section-${val}`);
      if (!el) return;
      el.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "center"
      });
    }
  },
  mounted() {
    const app = document.getElementById("app");
    if (app) {
      app.classList.add("bg-pure-white");
      app.classList.remove("bg-slate-200");
    }
    this.fetchReport();
  },
  destroyed() {
    const app = document.getElementById("app");
    if (app) {
      app.classList.remove("bg-pure-white");
      app.classList.add("bg-slate-200");
    }
  },
  methods: {
    ...mapActions(["getReport"]),
    async fetchReport() {
      const slug = this.$route.params.slug;

      this.pageLoading = true;
      await this.getReport({ slug });
      this.pageLoading = false;
    }
  }
};
</script>

<style lang="scss">
.bl-report-paper {
  color: var(--Slate-10, #1d2939);
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0.5px;
  text-align: left;
  h1 {
    font-size: 20px;
    font-weight: 700;
    line-height: 28px;
  }
  h2 {
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
  }
  h3 {
    font-size: 14px;
    font-weight: 600;
    line-height: 22px;
  }
  .ql-align-center {
    text-align: center;
  }
  .ql-align-right {
    text-align: right;
  }
  .ql-align-justify {
    text-align: justify;
  }
  ol,
  ul {
    padding-left: 1.5em;
  }
  h1,
  h2,
  h3,
  ol,
  p,
  ul {
    margin: 0;
    padding: 0;
    counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8
      list-9;
  }
  ol li:not(.ql-direction-rtl),
  ul li:not(.ql-direction-rtl) {
    padding-left: 1.5em;
  }
  ol li {
    counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8
      list-9;
    counter-increment: list-0;
  }
  ol > li,
  ul > li {
    list-style-type: none;
  }
  li:not(.ql-direction-rtl)::before {
    margin-left: -1.5em;
    margin-right: 0.3em;
    text-align: right;
  }
  ol li:before {
    content: counter(list-0, decimal) ". ";
  }
  ul > li::before {
    content: "\2022";
  }
  li::before {
    display: inline-block;
    white-space: nowrap;
    width: 1.2em;
  }
  a {
    color: #06c;
    text-decoration: underline;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/reports/ParentReport.vue